<template>
  <div v-if="childNode" class="centerDynamic_w overflow_hidden">
    <CardHead :title="childNode.nodeInfoVo.name" class="node_head">
      <div slot="oper"><router-link class="c_1A1A1A" :to="`${childNode.nodeInfoVo.nodeModel.route}/${childNode.nodeInfoVo.id}`">更多>></router-link></div>
    </CardHead>

    <div v-if="!childNode.articles || !childNode.articles.length" style="height:100%" class="x_y_center">
      <img src="@/assets/images/empty_icon.png" alt="">
      <span style="margin:0 0 0 10px" class="fz14">暂无数据</span>
    </div>

    <div ref="scrollRoot" class="content_w overflow_hidden fz14 ">
      <div ref="scrollBox">
        <router-link v-for="(item,index) in childNode.articles" :key="index" custom :to="`${childNode.nodeInfoVo.infoModel.route}/${item.id}`" class="item_i d_flex justify_content_sb">
          <span class="item_text text_ellipsis c_4D4D4D" @click="onLinkClick(item)">{{ item.title }}</span> <span class="c_808080">{{ formatDate(item.createdAt,'yyyy-MM-dd') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import CardHead from '@/components/template/CardHead.vue'

import { formatDate,  } from '@/utils'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

export default {
  components: {
    CardHead
  },
  inject: ['reload'],
  props: {
    code: {
      type: String,
      default: ''
    },
    nodeData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      childNode: null // 子栏目
    }
  },
  computed: {
    ...mapGetters(['nodeMap']),

    formatDate() {
      return function(date, format) {
        return formatDate(new Date(date), format)
      }
    }
  },
  watch:{
    nodeData:{
      handler(n){
        if(n.length){
          this.getData()
        }
      },
      immediate:true
    }
  },
  mounted() {

  },

  methods: {
    // 获取列表数据
    getData() {
      this.childNode = this.nodeData.find(i => i.nodeInfoVo.code === this.code)
    },
    // 点击链接
    onLinkClick(item) {
      console.log('onLinkClick')
    }

  }
}
</script>

<style lang="scss" scoped>
.centerDynamic_w {
  height: 270px;
  margin-top: 10px;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  .node_head{
      height: 44px;
      padding: 0 20px 0 10px;
      border-bottom: 1px solid #e6e6e6;
    }
  .content_w{
    height: 201px;
    padding: 0 20px;
  }
  .item_i{
    border-bottom: 1px solid #e6e6e6;
    padding: 13px 0;
    .item_text{
      width: 200px;
      &:hover{
      cursor: pointer;
      text-decoration: underline;
    }
    }
  }
}
</style>
